import { Box, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import { useGetUserId } from '../hooks/useGetUserId';
import axios from 'axios';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';

export default function RecipeCard({ recipe }) {
  const requestUrl = useGetRequestUrl();
  const [fav, setFav] = useState(false);
  const userId = useGetUserId();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/recipe/${recipe._id}`);
  };
  const titleStyles = {
    color: '#252525',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '24px',
  };
  const timeStyles = {
    color: '#DC582A',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '27px',
  };

  const handleFav = async () => {
    if (!userId) {
      navigate('/login');
    } else {
      const response = await axios.put(
        `${requestUrl}/recipe/`,
        {
          recipeId: recipe._id,
          userId: userId,
        },
        { withCredentials: false }
      );
      console.log(response);
      setFav(true);
      console.log(userId);
    }
  };

  const { title, description, imageUrl, timeToCook } = recipe;
  return (
    <Box
      height="330px"
      width="305px"
      sx={{
        cursor: 'pointer',
        verticalAlign: 'middle',
        display: 'block',
        borderRadius: '5px',
        boxShadow:
          '0px 3px 8px -1px rgba(50, 50, 71, 0.05), 0px 0px 1px 0px rgba(12, 26, 75, 0.24)',
      }}
    >
      <Box justifyContent="center" alignItems="center" onClick={handleClick}>
        <img
          src={imageUrl}
          alt="recipe"
          width="289px"
          height="200px"
          justifyContent="center"
          className="recipe-card-img"
        />
      </Box>
      <Box className="recipe-card-data" width="261px" height="59px">
        <Stack direction="row" justifyContent="flex-start">
          <Typography
            className="title"
            style={titleStyles}
            sx={{ fontFamily: 'Ubuntu' }}
          >
            {title}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          width="261px"
          justifyContent="space-between"
          mt="8px"
        >
          <Stack justifyContent="flex-start">
            <Typography style={timeStyles}>{timeToCook} min</Typography>
          </Stack>
          <Stack justifyContent="flex-end">
            {fav && <FavoriteIcon color="red" fontSize="small" />}
            {!fav && userId && (
              <FavoriteBorderOutlinedIcon
                fontSize="small"
                sx={{ cursor: 'pointer' }}
                onClick={handleFav}
              />
            )}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
